import React, { Fragment, useContext, useState, useEffect } from "react";

import Container from "./Container";
import FormInput from "../Elements/Form/FormInput";
import Button from "../Elements/Button";
import useHomeImages from "../StaticPages/hooks/useHomeImages";
import NavbarSignIn from "./NavbarSignIn";
import Img from "gatsby-image";
import { Form, Formik } from "formik";
import { payorlinkLoginSchema } from "./utils/payorlinkLoginSchema";
import { isBrowser } from "../../services/general";

const PrivateRoute = ({ children }) => {
  const [sessionMemberId, setSessionMemberId] = useState(() => {
    if (isBrowser())
      return sessionStorage.getItem("authState")
        ? JSON.parse(sessionStorage?.getItem("authState"))?.icareMemberId
        : "";
  });
  const data = useHomeImages();
  const logo = data?.logo?.childImageSharp?.fixed;
  const handleSubmit = async (values) => {
    sessionStorage.setItem(
      "authState",
      JSON.stringify({ icareMemberId: values.icareMemberId })
    );
    setSessionMemberId(values.icareMemberId);
  };
  return (
    <Fragment>
      {sessionMemberId && children}
      {!sessionMemberId && (
        <Container desktop={6} isCentered={true} showSideMargin={true}>
          <NavbarSignIn />
          <div className="columns is-12 mt-6 is-vcentered is-centered">
            <Img
              fixed={logo}
              alt="Foundever"
              className="column is-6-tablet is-4-mobile"
            />
            <p className="column is-8 is-size-2">Medicine Program</p>
          </div>
          <div className="columns is-8 is-centered">
            <div className="column is-10 mb-2 has-background-white p-2 border box">
              <Formik
                initialValues={{
                  icareMemberId: "",
                }}
                onSubmit={handleSubmit}
                validationSchema={payorlinkLoginSchema}
              >
                {({ values, errors, setErrors }) => (
                  <Form>
                    <FormInput
                      name="icareMemberId"
                      label="iCare Member ID"
                      placeholder="03######"
                      type={"text"}
                      maxLength={50}
                      isRequired
                    />
                    <Button
                      type="submit"
                      color="primary"
                      className="is-fullwidth"
                    >
                      Verify
                    </Button>
                    <p className="mt-2 is-size-6">Can't access your account?</p>
                    <p className="is-size-6">
                      Email us at{" "}
                      <a href="mailto:foundever.med@medgrocer.com">
                        foundever.med@medgrocer.com
                      </a>
                    </p>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Container>
      )}
    </Fragment>
  );
};

export default PrivateRoute;
